// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__29dVH","select":"Header_select__2OaCF","clinic":"Header_clinic__3zojp"};